<script setup>
import ModalWrapper from '@/modals/ModalWrapper';
import { watch, ref } from 'vue';

const props = defineProps({
    item: {
        type: Object,
        default: () => ({
            name: '',
        })
    },

    mode: {
        type: String,
        default: 'Create'
    }
});

const form = ref({
    name: ''
});

watch(() => props.item, (item) => {
    form.value = {
        name: item.name,
    };
}, { immediate: true });

</script>

<template>
<ModalWrapper>
    <template #header>Create/Edit Item</template>

    <form @submit.prevent="save">
        <div class="md:grid md:grid-cols-2 md:gap-4">
            <StyledInput
                v-model="form.name"
                label="Name"
                name="name" />
        </div>
    </form>

    <template #footer>
        <StyledSaveButton modal @save="save" />
    </template>
</ModalWrapper>
</template>
